@if (measuring && (measurementOuterRing.length > 0 || measurementHoles.length > 0)) {
    <div class="measurement-results">
        <div class="card">
            <div class="card-body">
                <div class="d-flex justify-content-between align-items-center">
                    <h6 class="card-title mb-0">Meetresultaten</h6>
                    <div class="d-flex align-items-center">
                        @if (measurementOuterRing.length >= 3) {
                            <button type="button" class="btn btn-sm btn-link" (click)="saveMeasurementAsWorkarea()">
                                <i class="fal fa-save"></i>
                            </button>
                        }
                        @if (measurementOuterRing.length === 4) {
                            <button type="button" class="btn btn-sm btn-link" (click)="copyLongestLengthString()">
                                <i class="fal fa-copy"></i>
                            </button>
                        }
                        <button
                            type="button"
                            class="btn btn-sm btn-link"
                            (click)="undoLastMeasurementPoint()"
                            [disabled]="
                                (!isCreatingHole && measurementOuterRing.length === 0) ||
                                (isCreatingHole &&
                                    (!measurementHoles[currentHoleIndex] ||
                                        measurementHoles[currentHoleIndex].length === 0))
                            ">
                            <i class="fal fa-undo"></i>
                        </button>
                        <button type="button" class="btn btn-sm btn-link" (click)="disableMeasurement()">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>
                </div>

                @if (measurementOuterRing.length >= 3) {
                    <div class="mb-3 measurement-actions">
                        <button
                            type="button"
                            [matButton]="isCreatingHole ? 'outlined' : 'filled'"
                            color="primary"
                            (click)="isCreatingHole = false">
                            <i class="fal fa-draw-polygon"></i> Buitenrand
                        </button>
                        <button
                            type="button"
                            [matButton]="isCreatingHole ? 'filled' : 'outlined'"
                            class="warning"
                            (click)="toggleHoleMode()">
                            <i class="fal fa-circle"></i> Uitsnede
                        </button>
                        @if (selectedPointsInPolygon.length > 0) {
                            <button
                                type="button"
                                matButton="filled"
                                class="success"
                                (click)="openExportDialog.emit()"
                                [disabled]="exportingSelectionExcel">
                                @if (!exportingSelectionExcel) {
                                    <i class="fal fa-file-excel"></i>
                                }
                                @if (exportingSelectionExcel) {
                                    <i class="fal fa-spinner fa-spin"></i>
                                }
                                Excel
                            </button>
                            @if (Functionalities.GeoTransferWorkareas | hasFunctionality) {
                                <button
                                    type="button"
                                    matButton="outlined"
                                    color="primary"
                                    (click)="openTransferDialog.emit()">
                                    <i class="fal fa-share"></i> Verplaatsen
                                </button>
                            }
                        }
                    </div>
                }

                @if (measuring && measurementOuterRing.length >= 2) {
                    <div>
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <strong>{{ measurementResult.area | formattedArea }}</strong>
                            <strong
                                style="cursor: pointer"
                                (contextmenu)="toggleSegmentExclusionAll($event)"
                                (click)="toggleLabelsVisibility()"
                                title="Klik om labels te tonen/verbergen">
                                {{ measurementResult.distance | formattedDistance }}
                            </strong>
                        </div>
                        @if (measurementHoles.length > 0) {
                            <p>
                                <span class="text-muted ms-2">
                                    <small style="font-size: 0.8rem">
                                        exclusief {{ measurementHoles.length }} uitsnede{{
                                            measurementHoles.length > 1 ? 's' : ''
                                        }}
                                    </small>
                                </span>
                            </p>
                        }
                        @if (measurementOuterRing.length >= 3) {
                            <p class="mb-2">
                                <small class="text-success">
                                    {{ selectedPointsInPolygon.length }} werkvak{{
                                        selectedPointsInPolygon.length === 1 ? '' : 'ken'
                                    }}
                                    in selectie
                                </small>
                            </p>
                        }

                        @if (measurementResult.segmentDistances.length > 0) {
                            <div>
                                <h6 class="segment-title d-none d-md-block">Zijdelengtes buitenrand:</h6>
                                <div class="segment-list">
                                    @for (distance of measurementResult.segmentDistances; track $index) {
                                        <div
                                            class="segment-item"
                                            [class.excluded]="isSegmentExcluded($index)"
                                            (contextmenu)="toggleSegmentExclusion($index, $event)">
                                            <small class="segment-label">Zijde {{ $index + 1 }}:</small>
                                            <small class="segment-distance">
                                                <strong>{{ distance | formattedDistance }}</strong>
                                            </small>
                                        </div>
                                    }
                                </div>
                            </div>
                        }

                        @for (holeDistances of measurementResult.holeSegmentDistances; track $index) {
                            @if (holeDistances.length > 0) {
                                <div class="mt-3">
                                    <h6 class="segment-title d-none d-md-block text-warning">
                                        Zijdelengtes uitsnede {{ $index + 1 }}:
                                    </h6>
                                    <div class="segment-list">
                                        @for (distance of holeDistances; track $index) {
                                            <div class="segment-item">
                                                <small class="segment-label">Zijde {{ $index + 1 }}:</small>
                                                <small class="segment-distance">
                                                    <strong>{{ distance | formattedDistance }}</strong>
                                                </small>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        }

                        @if (isCreatingHole) {
                            <div class="mt-2">
                                <small class="text-info">
                                    <i class="fal fa-info-circle"></i>
                                    Klik in de blauwe selectie om een uitsnede te maken.
                                    <button type="button" class="btn btn-sm btn-link p-0" (click)="addNewHole()">
                                        Nieuwe uitsnede
                                    </button>
                                </small>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    </div>
}
